export default __webpack_public_path__ + "static/media/conversation.b3c554fa.svg";